import React from "react";
import { getClassName } from "@sscs/utils";
import styles from "./levelDiamond.module.scss";
const LevelDiamond = ({ level, prefix, attained, size = "medium", }) => (React.createElement("div", { className: getClassName(styles.diamond, {
        [styles.small]: size === "small",
        [styles.attained]: attained,
        [styles.unattained]: !attained,
    }) },
    React.createElement("span", { className: styles.label },
        prefix,
        level)));
export default LevelDiamond;
//# sourceMappingURL=LevelDiamond.js.map